import {defineMessages} from 'react-intl';

export default defineMessages({
    incompatibleBrowser: {
        id: 'app.incompatibleBrowserPrompt.incompatibleBrowser',
        defaultMessage: 'You are using an unsupported browser. For best possible experience, please download {chromeLink}.'
    }
});
